"use client"
import { useState, useEffect } from 'react'

/**
 * Custom hook to detect screen size and determine if it's mobile or desktop
 * @returns {boolean} true if mobile (< 1024px), false if desktop (>= 1024px)
 */
const useResponsive = () => {
  // Start unknown; decide after first client paint to avoid SSR/hydration mismatches
  const [isMobile, setIsMobile] = useState(null)

  useEffect(() => {
    // Function to check and update screen size
    const checkScreenSize = () => {
      if (typeof window !== 'undefined') {
        setIsMobile(window.innerWidth < 1024)
      }
    }

    // Set initial value immediately on client
    checkScreenSize()

    // Add resize event listener with debounce for better performance
    let timeoutId
    const handleResize = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(checkScreenSize, 100)
    }

    window.addEventListener('resize', handleResize)

    // Cleanup
    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return isMobile
}

export default useResponsive

